module.exports = __webpack_public_path__ + "static/fluidlogo-5f0d7f59567d400ff0d09aaf62e63bdb.gif";